import { TemperatureCalibrationOutputWithStatus } from './temperature-calibration-output-with-status.model';


export class TemperatureCalibrationSelectAllOutput implements ITemperatureCalibrationSelectAllOutput {
    status!: number;
    message!: string;
    data!: TemperatureCalibrationOutputWithStatus[];

    constructor(data?: ITemperatureCalibrationSelectAllOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TemperatureCalibrationOutputWithStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TemperatureCalibrationSelectAllOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TemperatureCalibrationSelectAllOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITemperatureCalibrationSelectAllOutput {
    status: number;
    message: string;
    data: TemperatureCalibrationOutputWithStatus[];
}

